import { ProjectFilters } from '@/data/services/projectServices';
import { ProjectFiltersFields } from './ProjectPageFilters';
import useStudentContext from '@/data/hook/useStudentContext';
import useAuth from '@/data/hook/useAuth';

const useProjectFieldsAdapter = (
  fields: ProjectFiltersFields,
): ProjectFilters => {
  const projectFilters: ProjectFilters = {};
  const { klass, progress } = useStudentContext();
  const { user } = useAuth();
  const coursesAbbreviations =
    progress
      ?.map(({ coursePath: { course } }) => course.abbreviation)
      .join(',') || '';
  if (fields.restrict === 'mycourse')
    projectFilters.courseAbbreviation = coursesAbbreviations;
  if (fields.restrict === 'myklass') projectFilters.klass = klass?.id;
  if (fields.restrict === 'myschool') projectFilters.unitId = user?.unitsIds;

  projectFilters.search = fields.search;
  projectFilters.toolsId = fields.toolsId;
  return projectFilters;
};

export default useProjectFieldsAdapter;
